import React, {useEffect, useState} from 'react';

const FormObserver = ({onChange, values}) => {
    const [initialLoad, setInitialLoad] = useState(true)

    useEffect(() => {
        if(initialLoad) return setInitialLoad(false);

        onChange(values)
    }, [values])

    return <></>
};

export default FormObserver;